function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { genComponentStyleHook } from '../../theme/internal';

var genWaveStyle = function genWaveStyle(token) {
  var componentCls = token.componentCls,
      colorPrimary = token.colorPrimary;
  return _defineProperty({}, componentCls, {
    position: 'absolute',
    background: 'transparent',
    pointerEvents: 'none',
    boxSizing: 'border-box',
    color: "var(--wave-color, ".concat(colorPrimary, ")"),
    boxShadow: "0 0 0 0 currentcolor",
    opacity: 0.2,
    // =================== Motion ===================
    '&.wave-motion-appear': {
      transition: ["box-shadow 0.4s ".concat(token.motionEaseOutCirc), "opacity 2s ".concat(token.motionEaseOutCirc)].join(','),
      '&-active': {
        boxShadow: "0 0 0 6px currentcolor",
        opacity: 0
      },
      '&.wave-quick': {
        transition: ["box-shadow 0.3s ".concat(token.motionEaseInOut), "opacity 0.35s ".concat(token.motionEaseInOut)].join(',')
      }
    }
  });
};

export default genComponentStyleHook('Wave', function (token) {
  return [genWaveStyle(token)];
});